import { z } from "zod";
import { ConnectorType } from "../connector";
export var VehicleType;
(function (VehicleType) {
    VehicleType["CAR"] = "car";
    VehicleType["SUV"] = "suv";
    VehicleType["TRUCK"] = "truck";
    VehicleType["VAN"] = "van";
    VehicleType["MOTORBIKE"] = "motorbike";
    VehicleType["MICROCAR"] = "microcar";
    VehicleType["BUS"] = "bus";
    VehicleType["CONVERTIBLE"] = "convertible";
    VehicleType["COUPE"] = "coupe";
    VehicleType["HATCHBACK"] = "hatchback";
    VehicleType["SEDAN"] = "sedan";
    VehicleType["WAGON"] = "wagon";
    VehicleType["MINIVAN"] = "minivan";
    VehicleType["PICKUP"] = "pickup";
    VehicleType["OTHER"] = "other";
})(VehicleType || (VehicleType = {}));
export const zDcChargingCurve = z.object({
    percentage: z.number(),
    power: z.number(),
});
export const zVehicleModelCommonSchema = z.object({
    id: z.string(),
    manufacturer_id: z.string().nullish(),
    model: z.string(),
    usable_battery_size: z.number(),
    dc_ports: z.array(z.enum(ConnectorType)),
    vehicle_type: z.enum(VehicleType),
    release_year: z.number().nullish(),
    release_month: z.number().nullish(),
    dc_max_power: z.number(),
    dc_charging_curve: z.array(zDcChargingCurve),
    dc_is_default_charging_curve: z.boolean(),
});
export const zVehicleModelFiltersSchema = z.object({
    search: z.string().optional(),
});
